import { createContext, useContext } from 'react'
import { FeatureResponse } from 'types'

const FeatureCtx = createContext<FeatureResponse>({ features: null })

export function FeatureProvider({ value, children }) {
  // Ensure we always provide an object with features property, even when value is null
  const contextValue = value ? value : { features: null }
  return <FeatureCtx.Provider value={contextValue}>{children}</FeatureCtx.Provider>
}

export const useFeatureCtx = () => {
  return useContext(FeatureCtx)
}
